import React, { Fragment } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { message } from 'antd'
import { CouponRegisterInfo } from '@store/componentStore'
import { COUPON_RESULT_CODE } from '@constants/index'
// img
import ResetBtn from '@assets/images/coupon/reset-btn.png'
import CouponBgCenter from '@assets/images/coupon/coupon-bg-center.png'
import CouponBgBottom from '@assets/images/coupon/coupon-bg-bottom.png'
import CouponTxt from '@assets/images/coupon/coupon-txt.png'
// icon
import { ArrowIco } from '@shared/Icon/ArrowIcon'

// css
import {
  TitleWrap,
} from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import NavBar from '@views/Navbar'
import CouponNotice from '../CouponNotice/index'
import { CouponWrap } from '../index.style'
import { appScrollTo, loadOrReload } from '@utils/utils'
import PopupUtils from '@utils/popup-utils'

const COUPON_ID_REGEX = /^(([A-Za-z0-9]){4}-)([A-Za-z0-9]){4}-([A-Za-z0-9]){4}(-([A-Za-z0-9]){4})$/g

const CouponInput: React.FC = props => {
  const { authStore, routerStore, componentStore } = useRootStore()

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      loadOrReload('/')
    }

    if (!componentStore.isCouponInputViewCallFromCouponCheckView) {
      componentStore.initCouponIdsVanillaTextAndCouponRegisterInfo()
    }

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  const couponIdsVanillaText = componentStore.couponIdsVanillaText

  // let contentWarpStyle
  // if (!isMobile) {
  //   contentWarpStyle = { overflow: 'auto', height: 'calc(100% - 40px)', background: 'none' }
  // }

  const onClickClearAll = () => {
    componentStore.initCouponIdsVanillaTextAndCouponRegisterInfo()
    message.info('쿠폰 번호가 모두 초기화되었습니다.')
  }

  const validateCouponDuplicate = () => {
    let result = true

    if (!componentStore.couponIdsVanillaText
      || !componentStore.couponRegisterInfos || componentStore.couponRegisterInfos.length === 0) {
      result = false
    }

    if (result) {
      for (const info of componentStore.couponRegisterInfos) {
        const couponId = info.couponId
        const duplicatedInfos = componentStore.couponRegisterInfos.filter(targetInfo => {
          return targetInfo.couponId.toLowerCase() === couponId.toLowerCase()
        })
        if (duplicatedInfos.length > 1) {
          result = false
          break
        }
      }
    }

    if (!result) {
      message.info('동일한 쿠폰은 1개만 입력할 수 있습니다.')
    }

    return result
  }

  const validateCouponsForMatch = () => {
    let result = true

    if (!componentStore.couponIdsVanillaText
      || !componentStore.couponRegisterInfos || componentStore.couponRegisterInfos.length === 0) {
      result = false
      message.info('쿠폰 번호를 입력해주세요.')
    }

    if (result) {
      const infos = componentStore.couponRegisterInfos
      for (const info of infos) {
        if (!info.couponId.match(COUPON_ID_REGEX)) {
          message.info('쿠폰 번호를 확인해주세요.')
          result = false
          break
        }
      }
    }

    return result
  }

  const onClickValidateCoupons = () => {
    // 클라이언트 유효성 체크
    if (!validateCouponsForMatch() || !validateCouponDuplicate()) {
      return
    }

    if (isMobile) {
      loadOrReload('/coupon-check')
    } else {
      PopupUtils.showCouponCheckPopup()
    }
  }

  const parseCouponIds = vanillaText => {
    const result = []
    if (vanillaText) {
      const couponIds = vanillaText.replace(/\r/gi, '').split('\n')
      for (const couponId of couponIds) {
        if (couponId) {
          result.push(couponId)
        }
      }
    }
    return result
  }

  const makeCouponRegisterInfo = couponId => {
    return {
      couponId,
      resultCode: COUPON_RESULT_CODE.UNKNOWN,
    }
  }

  const onChangeCouponIdsVanillaText = event => {
    const vanillaText = event.currentTarget.value
    componentStore.setCouponIdsVanillaText(vanillaText)

    const couponIds = parseCouponIds(vanillaText)
    const infos: CouponRegisterInfo[] = []
    couponIds.forEach(couponId => {
      infos.push(makeCouponRegisterInfo(couponId))
    })
    componentStore.setCouponRegisterInfos(infos)
  }

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap className="title-wrap white">
          <BackBtn onClick={() => routerStore.goBack()}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}


      <CouponWrap className={!isMobile && 'pc-coupon-wrap'}>
        {/*<img src={CouponBg} alt="쿠폰" className="coupon-bg"/>*/}
        <CouponNotice/>

        <div className="coupon-list">
          <img src={CouponBgCenter} alt="" className="coupon-bg center"/>
          <div className="coupon-list--box">
            <textarea name="couponInput" id="couponInput" placeholder="보유하신 쿠폰번호를 '-' 포함 모두 입력해주세요." maxLength={400} rows={20}
                      className="coupon-list--box--input" value={couponIdsVanillaText}
                      onChange={e => onChangeCouponIdsVanillaText(e)}/>
          </div>

          <div className="right-contents">
            <Button TP className="reset-btn" onClick={onClickClearAll}>
              <img src={ResetBtn} alt="초기화"/>
            </Button>

            <img src={CouponTxt} alt="coupon" className="coupon-img"/>
          </div>

          <Button TP className="coupon-btn" onClick={onClickValidateCoupons}>
            <img src={CouponBgBottom} alt="" className="coupon-bg bottom"/>
            쿠폰 유효성 체크
          </Button>
        </div>
      </CouponWrap>
      {isMobile && <NavBar key="CouponInput:NavBar"/>}
    </Fragment>
  )
}

export default observer(CouponInput)
